<template>
  <div v-if="scope.text.length>=2">

    <div>
      <span>{{ scope.text[0] }}
        <!-- <el-tooltip content="复制">
          <a-icon type="copy" style="color: #3f9dfe" @click="copyData(scope.text[0])" />
        </el-tooltip> -->
        <el-tooltip content="折叠" v-if="showToolTip[scope.index]">
          <i class="el-icon-caret-top iconMore" @click="openMore(scope.index)"></i>
        </el-tooltip>
        <el-tooltip content="展开更多" v-if="!showToolTip[scope.index]">
          <i class="el-icon-caret-bottom iconMore" @click="openMore(scope.index)"></i>
        </el-tooltip>
      </span>
      <div v-for="(con,index1) in scope.text" :key="index1" v-if="showToolTip[scope.index]">
        <div v-if="index1!==0">{{ con }}
          <!-- <el-tooltip content="复制">
            <a-icon type="copy" style="color: #3f9dfe" @click="copyData(con)" />
          </el-tooltip> -->
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    {{ scope.text[0] }} 
    <!-- <el-tooltip content="复制">
      <a-icon type="copy" style="color: #3f9dfe" @click="copyData(scope.text[0])" />
    </el-tooltip> -->
  </div>
</template>

<script>

import { copyText } from "@/utils/windowsUtils";

export default {
  name: "ExFoldTableCell",
  props: ['scope',],
  data() {
    return {
      showToolTip: [],
    }
  },
  methods: {
    openMore(index) {
      this.$set(this.showToolTip, index, !this.showToolTip[index]);
    },
    copyData(text) {
      copyText(text)
      this.$messageUi.success('复制成功')
    },
  }
}
</script>

<style scoped>
.iconMore {
  color: #4eaad4;
  cursor: pointer;
}

</style>
